import React from "react";

const icons = {
  // --- MEVCUT İKONLAR ---
  "icon-project": (
    <>
      <path d="M4.396 6.978c0.301-1.281 1.301-2.282 2.582-2.582 1.11-0.26 2.266-0.26 3.377 0 1.281 0.301 2.282 1.301 2.582 2.582 0.26 1.11 0.26 2.266 0 3.377-0.301 1.281-1.301 2.282-2.582 2.582-1.11 0.26-2.266 0.26-3.377 0-1.281-0.3-2.282-1.301-2.582-2.582-0.26-1.11-0.26-2.266 0-3.377z" />
      <path d="M4.396 21.645c0.301-1.281 1.301-2.282 2.582-2.582 1.11-0.261 2.266-0.261 3.377 0 1.281 0.3 2.282 1.301 2.582 2.582 0.26 1.111 0.26 2.266 0 3.377-0.301 1.281-1.301 2.282-2.582 2.582-1.11 0.261-2.266 0.261-3.377 0-1.281-0.3-2.282-1.301-2.582-2.582-0.26-1.111-0.26-2.266 0-3.377z" />
      <path d="M19.063 6.978c0.3-1.281 1.301-2.282 2.582-2.582 1.111-0.26 2.266-0.26 3.377 0 1.281 0.301 2.282 1.301 2.582 2.582 0.261 1.11 0.261 2.266 0 3.377-0.3 1.281-1.301 2.282-2.582 2.582-1.111 0.26-2.266 0.26-3.377 0-1.281-0.3-2.282-1.301-2.582-2.582-0.261-1.11-0.261-2.266 0-3.377z" />
      <path d="M19.063 21.645c0.3-1.281 1.301-2.282 2.582-2.582 1.111-0.261 2.266-0.261 3.377 0 1.281 0.3 2.282 1.301 2.582 2.582 0.261 1.111 0.261 2.266 0 3.377-0.3 1.281-1.301 2.282-2.582 2.582-1.111 0.261-2.266 0.261-3.377 0-1.281-0.3-2.282-1.301-2.582-2.582-0.261-1.111-0.261-2.266 0-3.377z" />
    </>
  ),
  "icon-star": (
    <g transform="translate(2 2) scale(0.8)">
      <path d="M16 2.667l2.683 6.975c0.376 0.978 0.564 1.466 0.856 1.878 0.259 0.364 0.577 0.683 0.942 0.942 0.411 0.292 0.9 0.48 1.878 0.856l6.975 2.683-6.975 2.683c-0.978 0.376-1.466 0.564-1.878 0.856-0.364 0.259-0.683 0.577-0.942 0.942-0.292 0.411-0.48 0.9-0.856 1.878l-2.683 6.975-2.683-6.975c-0.376-0.978-0.564-1.466-0.856-1.878-0.259-0.364-0.578-0.683-0.942-0.942-0.292-0.411 0.48-0.9 0.856-1.878l2.683-6.975z" />
    </g>
  ),
  "icon-loading": (
    <path d="M4.454 22.666c-1.67-2.893-0.821-6.58 1.944-8.453l0.003-0.003c2.221-1.501 5.143-1.45 7.312 0.126l4.576 3.327c2.167 1.576 5.090 1.627 7.312 0.126l0.003-0.003c2.766-1.872 3.616-5.563 1.943-8.453M22.669 27.546c-2.893 1.669-6.58 0.821-8.453-1.944l-0.003-0.003c-1.501-2.221-1.45-5.143 0.126-7.312l3.327-4.576c1.576-2.167 1.627-5.090 0.126-7.312l-0.006-0.003c-1.872-2.763-5.563-3.615-8.453-1.942M25.427 6.572c5.207 5.207 5.207 13.648 0 18.855s-13.648 5.207-18.855 0c-5.207-5.207-5.207-13.648 0-18.855s13.648-5.207 18.855 0z" />
  ),
  "icon-puzzle-piece": (
    <path d="M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z" />
  ),
  "icon-container": (
    <path d="M27.333 9.704l-11.333 6.296M16 16l-11.333-6.296M16 16l0 12.667M28 21.411v-10.823c0-0.457 0-0.685-0.067-0.889-0.060-0.18-0.157-0.346-0.285-0.485-0.145-0.158-0.345-0.269-0.744-0.491l-9.867-5.481c-0.378-0.21-0.567-0.315-0.767-0.356-0.177-0.036-0.36-0.036-0.537 0-0.2 0.041-0.389 0.146-0.767 0.356l-9.867 5.481c-0.399 0.222-0.599 0.333-0.744 0.491-0.129 0.14-0.226 0.305-0.285-0.485 0.067-0.204 0.067-0.432 0.067-0.889v10.823c0 0.457 0 0.685 0.067 0.889 0.060 0.18 0.157 0.346 0.286 0.485 0.145 0.158 0.345-0.269 0.744 0.491l9.867 5.482c0.378 0.21 0.567 0.315 0.767 0.356 0.177 0.036 0.36 0.036 0.537 0 0.2-0.041 0.389-0.146 0.767-0.356l9.867-5.482c0.399-0.222 0.599-0.333 0.744-0.491-0.129-0.14 0.226-0.305-0.285-0.485 0.067-0.204 0.067-0.432 0.067-0.889z" />
  ),
  "icon-lightning": (
    <path d="M18.999 2.667h-7.674c-0.239 0-0.359 0-0.465 0.036-0.093 0.032-0.178 0.085-0.249 0.154-0.080 0.078-0.133 0.185-0.24 0.399l-5.6 11.2c-0.256 0.511-0.383 0.767-0.353 0.974 0.027 0.181 0.127 0.344 0.277 0.449 0.172 0.12 0.458 0.12 1.029 0.12h8.274l-4 13.333 16.258-16.86c0.548-0.569 0.823-0.853 0.839-1.097 0.014-0.211-0.073-0.417-0.235-0.553-0.186-0.157-0.581-0.157-1.372-0.157h-9.49l3-8z" />
  ),
  "icon-colors": (
    <path d="M16 27.296c1.415 1.267 3.284 2.037 5.333 2.037 4.418 0 8-3.582 8-8 0-3.689-2.497-6.795-5.893-7.72M8.56 13.614c-3.396 0.925-5.894 4.031-5.894 7.72 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.041-0.199-2.035-0.56-2.947M24 10.667c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8c4.418 0 8 3.582 8 8z" />
  ),
  "icon-hexagon": (
    <path d="M14.964 3.242c0.378-0.21 0.567-0.315 0.767-0.356 0.177-0.036 0.36-0.036 0.537 0 0.2 0.041 0.389 0.146 0.767 0.356l9.867 5.482c0.399 0.222 0.599 0.333 0.744 0.491 0.129 0.14 0.226 0.305 0.285 0.485 0.067 0.204 0.067 0.432 0.067 0.889v10.823c0 0.457 0 0.685-0.067 0.889-0.060 0.18-0.157 0.346-0.285 0.485-0.145 0.158-0.345 0.269-0.744 0.491l-9.867 5.482c-0.378 0.21-0.567 0.315-0.767 0.356-0.177 0.036-0.36 0.036-0.537 0-0.2-0.041-0.389-0.146-0.767-0.356l-9.867-5.482c-0.399-0.222-0.599-0.333-0.744-0.491-0.129-0.14-0.226-0.305-0.286-0.485-0.067-0.204-0.067-0.432-0.067-0.889v-10.823c0-0.457 0-0.685 0.067-0.889 0.060-0.18 0.157-0.346 0.286-0.485 0.145-0.158 0.345-0.269 0.744-0.491l9.867-5.481z" />
  ),
  "icon-block": (
    <>
      <path d="M16 10V22" stroke="#121212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 16H22" stroke="#121212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  "icon-push_pin": (
    <path
      d="M15.984 9v-5.016h1.031q0.375 0 0.68-0.281t0.305-0.703v0q0-0.422-0.305-0.703t-0.68-0.281h-10.031q-0.375 0-0.68 0.281t-0.305 0.703v0q0 0.422 0.305 0.703t0.68 0.281h1.031v5.016q0 0.844-0.422 1.523t-1.102 1.078-1.477 0.398v0 2.016h5.953v6.984l0.984 0.984 1.031-0.984v-6.984h6v-2.016q-0.797 0-1.477-0.398t-1.102-1.078-0.422-1.523z"
      fill="currentColor"
      stroke="none"
    />
  ),

  // --- YENİ EKLENENLER ---

  "icon-arrow-circle-broken": (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.6"
        d="M4.45 9.333A13.328 13.328 0 0 1 16 2.666c7.364 0 13.333 5.97 13.333 13.333S23.363 29.332 16 29.332a13.329 13.329 0 0 1-11.55-6.667"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.6"
        d="M16 21.333 21.333 16 16 10.667M2.667 16h18.667"
      />
    </>
  ),

  "icon-bell": (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M12.472 28c.94.83 2.175 1.333 3.528 1.333s2.588-.504 3.528-1.333M24 10.667a8 8 0 1 0-16 0c0 4.12-1.039 6.941-2.2 8.807-.979 1.574-1.469 2.361-1.451 2.58.02.243.071.336.267.481.177.131.974.131 2.569.131h17.63c1.595 0 2.392 0 2.569-.131.196-.145.247-.238.267-.481.018-.22-.472-1.006-1.451-2.58-1.161-1.866-2.2-4.687-2.2-8.807z"
    />
  ),

  "icon-chevron-down": (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.824"
      d="M8.471 12.235 16 19.764l7.529-7.529"
    />
  ),

  "icon-filter": (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M29.334 4H2.667l10.667 12.613v8.72L18.667 28V16.613L29.334 4z"
    />
  ),

  "icon-help-circle": (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.88"
        d="M16 29.333c7.364 0 13.333-5.969 13.333-13.333S23.363 2.667 16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.637 29.333 16 29.333z"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.88"
        d="M12.12 12a4.003 4.003 0 0 1 6.834-1.249c.608.722.941 1.637.94 2.582 0 2.667-4 4-4 4M16 22.667h.02"
      />
    </>
  ),

  "icon-login": (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.867 10.08c.413-4.8 2.88-6.76 8.28-6.76h.173c5.96 0 8.347 2.387 8.347 8.347v8.693c0 5.96-2.387 8.347-8.347 8.347h-.173c-5.36 0-7.827-1.933-8.267-6.653M2.667 16H19.84"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.867 11.533 21.334 16l-4.467 4.467"
      />
    </>
  ),

  "icon-logout": (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 8V6c0-1.105-0.895-2-2-2h-8c-1.105 0-2 0.895-2 2v20c0 1.105 0.895 2 2 2h8c1.105 0 2-0.895 2-2v-2"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M28 16H12m8-6 8 6-8 6"
      />
    </>
  ),

  // LOGO: Hem siyah hem de renkli kısmı olduğu için iki path'i ayrı renklendiriyoruz
  "icon-logo": (
    <>
      <path
        fill="currentColor"
        d="M26.667 0H5.334A5.333 5.333 0 0 0 .001 5.333v21.333a5.333 5.333 0 0 0 5.333 5.333h21.333A5.333 5.333 0 0 0 32 26.666V5.333A5.333 5.333 0 0 0 26.667 0z"
      />
      <path
        fill="#121212"
        d="M13.331 23.027c.244-1.272.453-2.61.747-3.949.145-.701-.032-.999-.815-.946s-1.657.027-2.49 0c-.833-.027-.982-.446-.502-1.044 2.363-2.918 4.753-5.8 7.134-8.674.267-.326.575-.558 1.014-.312s.349.549.276.915c-.263 1.339-.48 2.677-.77 3.989-.149.678.045.919.751.892a20.959 20.959 0 0 1 2.127 0c.403 0 .932-.21 1.141.339s-.231.781-.453 1.107a315.559 315.559 0 0 1-2.752 3.342 1579.8 1579.8 0 0 0-4.051 4.854c-.263.317-.557.571-1.005.41s-.353-.54-.353-.924z"
      />
    </>
  ),

  "icon-menu": (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M4 16h24"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M4 8h24"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M4 24h24"
      />
    </>
  ),

  // Pencil, Trash, X-close vb. zaten yukarıda vardı, aynı mantıkla güncellendi veya korundu.
  "icon-pencil": (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.6"
      d="m3.333 28.667 7.399-2.846c.473-.182.71-.273.931-.392.197-.106.384-.227.56-.364.199-.154.378-.333.736-.692l15.04-15.04A3.77 3.77 0 1 0 22.666 4L7.626 19.04c-.359.359-.538.538-.692.736a3.948 3.948 0 0 0-.364.56c-.119.221-.21.458-.392.931l-2.846 7.399zm0 0 2.744-7.135c.196-.511.295-.766.463-.883a.665.665 0 0 1 .505-.107c.201.038.395.232.782.619l3.012 3.012c.387.387.58.58.619.782a.665.665 0 0 1-.107.505c-.117.168-.372.267-.883.463l-7.135 2.744z"
    />
  ),

  "icon-plus": (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.88" d="M16 6.667v18.667M6.666 16h18.667" />
  ),

  "icon-trash": (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.6"
      d="M12 4h8M4 8h24M6.667 8l.801 12.018c.149 2.231.223 3.347.588 4.243a6 6 0 0 0 3.672 3.435c.919.304 2.037.304 4.273.304v0c2.236 0 3.354 0 4.273-.304a6 6 0 0 0 3.672-3.435c.365-.896.439-2.012.588-4.243L25.335 8"
    />
  ),

  "icon-x-close": (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.667"
      d="M24 8 8 24M8 8l16 16"
    />
  ),

  "icon-eye": (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.88"
        d="M1.333 16S6.666 5.333 16 5.333 30.667 16 30.667 16 25.334 26.667 16 26.667 1.333 16 1.333 16z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.88" d="M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
    </>
  ),

  "icon-eye-off": (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.88"
      d="M23.92 23.92A13.43 13.43 0 0 1 16 26.667C6.667 26.667 1.333 16 1.333 16A24.605 24.605 0 0 1 8.08 8.08m5.12-2.427a12.161 12.161 0 0 1 2.8-.32C25.333 5.333 30.667 16 30.667 16a24.646 24.646 0 0 1-2.88 4.253m-8.961-1.426a4.01 4.01 0 0 1-2.855 1.273 3.978 3.978 0 0 1-1.569-.291 3.984 3.984 0 0 1-2.21-2.21 3.995 3.995 0 0 1 .983-4.424M1.333 1.333l29.333 29.333"
    />
  ),

  "icon-user": (
    <>
      <path
        fill="#1f1f1f"
        d="M3.765 0h24.471c2.079 0 3.765 1.686 3.765 3.765v24.471c0 2.079-1.686 3.765-3.765 3.765h-24.471c-2.079 0-3.765-1.686-3.765-3.765v-24.471c0-2.079 1.686-3.765 3.765-3.765z"
      ></path>
      <path
        fill="#151515"
        d="M21.49 14.745c0 2.946-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.946 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333z"
      ></path>
      <path
        fill="#151515"
        d="M29.060 32.853c0-1.723-0.339-3.429-0.999-5.020s-1.626-3.038-2.844-4.256c-1.218-1.218-2.664-2.184-4.256-2.844s-3.297-0.999-5.020-0.999c-1.723 0-3.429 0.339-5.020 0.999s-3.038 1.626-4.256 2.844c-1.218 1.218-2.184 2.664-2.844 4.256s-0.999 3.297-0.999 5.020h26.237z"
      ></path>
    </>
  ),

  "icon-block-background": (
    <>
      <path d="M25.143 0h-18.286c-3.787 0-6.857 3.070-6.857 6.857v18.286c0 3.787 3.070 6.857 6.857 6.857h18.286c3.787 0 6.857-3.070 6.857-6.857v-18.286c0-3.787-3.070-6.857-6.857-6.857z"></path>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.1429"
        d="M21.333 22.857h0.77c0.74 0 1.11 0 1.314-0.154 0.178-0.134 0.288-0.34 0.301-0.562 0.015-0.255-0.19-0.563-0.6-1.179l-2.294-3.44c-0.339-0.509-0.509-0.763-0.723-0.852-0.187-0.078-0.397-0.078-0.584 0-0.214 0.089-0.383 0.343-0.723 0.852l-0.567 0.851M21.333 22.857l-5.855-8.457c-0.337-0.486-0.505-0.729-0.715-0.815-0.184-0.075-0.39-0.075-0.574 0-0.2 0.085-0.379 0.329-0.715 0.815l-4.531 6.544c-0.429 0.62-0.643 0.929-0.631 1.187 0.011 0.224 0.12 0.433 0.298 0.569 0.205 0.157 0.582 0.157 1.335 0.157h11.388zM22.857 11.429c0 1.262-1.023 2.286-2.286 2.286s-2.286-1.023-2.286-2.286c0-1.262 1.023-2.286 2.286-2.286s2.286 1.023 2.286 2.286z"
      ></path>
    </>
  ),

  // Varsayılan
  default: (
    <path d="M4.396 6.978c0.301-1.281 1.301-2.282 2.582-2.582 1.11-0.26 2.266-0.26 3.377 0 1.281 0.301 2.282 1.301 2.582 2.582 0.26 1.11 0.26 2.266 0 3.377-0.301 1.281-1.301 2.282-2.582 2.582-1.11 0.26-2.266 0.26-3.377 0-1.281-0.3-2.282-1.301-2.582-2.582-0.26-1.11-0.26-2.266 0-3.377z" />
  ),
};

function SvgIcon({
  iconName,
  size = 18,
  className,
  viewBox = "0 0 32 32",
  color = "currentColor",
  fill = "currentColor",
  strokeWidth,
  ...props
}) {
  const content = icons[iconName] || icons["default"];

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill={fill ?? "currentColor"}
      stroke={color}
      strokeWidth={strokeWidth}
      className={className}
      style={{ minWidth: size }}
      {...props}
    >
      {content}
    </svg>
  );
}

export default SvgIcon;
